<script>
import appUrl from 'lib/appUrl.js';
import { movementParameters, partialStrings } from 'config';
import MovementImages from './MovementImages.vue';
import MovementTextNotes from './MovementTextNotes.vue';
import MovementArtworksImages from './MovementArtworksImages.vue';
import { HideIfEmpty } from 'directives/HideIfEmpty';
import template from '../../views/partials/movements/exhibition.html';

export default {
  name: 'MovementSidebarDetailsExhibition',
  template,
  props: {
    movement: Object,
  },
  directives: {
    HideIfEmpty,
  },
  components: {
    MovementImages,
    MovementTextNotes,
    MovementArtworksImages,
  },
  computed: {
    lang() {
      return this.$language.current;
    },
    showTextNoteLabel() {
      return movementParameters.show_text_note_label[this.lang];
    },
    textNotes() {
      return this.movement.text_notes?.movement;
    },
  },
  methods: {
    goToArtworks() {
      const url = `${appUrl}artworks?movement_id=${this.movement._id}`;
      return window.open(url, '_blank');
    },
  },
  data() {
    return {
      partial: partialStrings,
      movementParameters,
    };
  },
};
</script>
